const {useState} = require('react');
const {default: BaseAPI} = require('web/redux/actions/BaseAPI');
const {default: store} = require('web/redux/store');

/**
 *
 */
export default function useDispathModel() {
  const [assignmentEmployee, setAssignmentEmployee] = useState(null);
  const fetchAssignmentEmployee = async (assignmentId) => {
    try {
      const token = store.getState().auth.token;
      const data = await BaseAPI.getWithAuth(
        `dispatch/${assignmentId}`,
        {
          includeEnded: true,
        },
        token,
      );
      const result = data.result;
      setAssignmentEmployee(result);
      setAssignmentEndTime();
    } catch (error) {
      console.error(error);
    }
  };

  const statusEnum = {
    isAccountable: {
      className: 'status-rush',
      title: '當責',
    },
    isNotAccountability: {
      className: 'status-normal',
      title: '指派人員',
    },
    hasWorkEndTime: {
      className: 'status-secondary',
      title: '已結束',
    },
  };

  return {
    assignmentEmployee,
    fetchAssignmentEmployee,
    statusEnum,
  };
}
